<ion-header>
	<ion-toolbar>
		<ion-buttons slot="primary">
			<ion-button (click)="dismiss()"> {{ 'Close' | translate }} </ion-button>
		</ion-buttons>
		<ion-title>{{ title | translate }} <ng-container *ngIf="image?.sequence">#{{image?.sequence}}</ng-container></ion-title>
	</ion-toolbar>
</ion-header>
<ion-content scrollX="false" scrollY="false">
	<ion-refresher slot="fixed" (ionRefresh)="dismiss()"></ion-refresher>
  <div class="container" fxFill fxLayout="row" fxLayoutAlign="center center" >
    <swiper-container #swiper (slidechangetransitionend)="slideDidChange($event)" zoom="true">
      <swiper-slide *ngFor="let image of images">
        <div
            class="swiper-zoom-container"
            [class.site-map-loading]="!image.loaded">
            <div class="img-wrapper">
                <img
                #photoImg
                [src]="imageCache(image)"
                (load)="image.loaded = true"
                (error)="photoImg.src = '/assets/image/image-off.svg'">
            </div>
          </div>
      </swiper-slide>
    </swiper-container>
  </div>
</ion-content>
